<div class="keyboard-key px-2 mx-2 d-flex justify-content-center align-items-center">
    <ng-content></ng-content>
</div>
